import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const payForAnyUnpaidServices = async (phoneNumber: string) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
    },
    mutation: graphql(`
      mutation PayForAnyUnpaidServices($phoneNumber: String!) {
        payForAnyUnpaidServices(phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.payForAnyUnpaidServices ?? '';
};
